export enum ComponentPermission {
	GRANT_ACCESS = 'grantAccess',
	NO_CHANGES = 'noChanges'
}